/**
 * @file paddlex 用户信息
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {Alert} from 'antd';

import Header from '../../../../components/header/HeaderWithStore';
import Banner from '../../../../components/banner/Banner';
import Footer from '../../../../components/footer/footer';
import UserInfoForm from './components/user-info-form/UserInfoForm';
import useUserInfoHooks from './userInfoHooks';

const UserInfo: React.FC = () => {
    const {
        userInfoForm,
        verifyCodeImg,
        getVerifyCode,
        onFormSubmit,
        onFormCancel
    } = useUserInfoHooks();

    return (
        <div className="page paddle-lab-user-info-page">
            <Header />
            <Banner
                title="个人信息"
                className="paddle-lab-user-info-banner"
                subtitle="为了更好的了解您的实际需求，方便您与飞桨团队反馈交流，烦请您填写个人基本信息，感谢您对飞桨团队的支持与配合！"
                divider
            />
            <div className="paddle-lab-user-info-container">
                <Alert
                    className="paddle-lab-user-info-alert"
                    message="PaddleX的下载链接将会在您提交个人基本信息后生成"
                    type="info"
                />

                <UserInfoForm
                    form={userInfoForm}
                    verifyCodeImg={verifyCodeImg}
                    getVerifyCode={getVerifyCode}
                    onFormSubmit={onFormSubmit}
                    onFormCancel={onFormCancel}
                />
            </div>
            <Footer />
        </div>
    );
};

export default UserInfo;
